// extracted by mini-css-extract-plugin
module.exports = {"privacyDesktopModule":"privacy_privacyDesktopModule__CLZHD","privacyPolicyContainer":"privacy_privacyPolicyContainer__UdlNa","moreHelp":"privacy_moreHelp__DeN9E"};